'use client';

import Link from 'next/link';
import type { NearbySportEvent } from '@bip/api-client';
import './NearbySportCard.css';

function formatEventDate(dateOfEvent: string, timeOfEvent: string): string {
  try {
    const [dd, mm, yyyy] = dateOfEvent.split('/');
    const d = new Date(`${yyyy}-${mm}-${dd}T${timeOfEvent}`);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ];
    const day = d.getDate();
    const sfx = ['th', 'st', 'nd', 'rd'][day % 10 <= 3 && Math.floor(day / 10) !== 1 ? day % 10 : 0];
    return `${days[d.getDay()]}, ${day}${sfx} ${months[d.getMonth()]} ${d.getFullYear()} - ${timeOfEvent}`;
  } catch {
    return `${dateOfEvent} - ${timeOfEvent}`;
  }
}

export function NearbySportCard({
  event,
  referenceName,
}: {
  event: NearbySportEvent;
  referenceName?: string;
}) {
  return (
    <div className="rns-card">
      <div className="rns-topstrip">
        <span className="rns-category">{event.eventType.name}</span>
      </div>

      <div className="rns-body">
        <div className="rns-name">{event.name}</div>

        {event.tournament && (
          <div className="rns-meta">
            <i className="text-lg fal fa-trophy rns-meta__icon" />
            {event.tournament.name}
          </div>
        )}

        <div className="rns-meta">
          <i className="text-lg fal fa-map-marker-alt rns-meta__icon" />
          {[event.city.name, event.country.name].filter(Boolean).join(', ')}
          {event.distanceInMiles != null && (
            <>, {event.distanceInMiles.toFixed(1)} miles {referenceName ? ` from ${referenceName}` : ''}</>
          )}
        </div>

        <div className="rns-meta">
          <i className="text-lg fal fa-calendar rns-meta__icon" />
          {formatEventDate(event.dateOfEvent, event.timeOfEvent)}
          {event.distanceInMiles != null && (
            <>, {event.distanceInMiles.toFixed(1)} miles {referenceName ? ` from ${referenceName}` : ''}</>
          )}
        </div>

        {event.minTicketPrice.price != null && (
          <div className="rns-price">
            From {event.minTicketPrice.currencySymbol}
            {event.minTicketPrice.price.toLocaleString('en-GB', { minimumFractionDigits: 2 })}
          </div>
        )}
      </div>

      <div className="rns-footer">
        <Link
          href={event.detailPageUrl ?? `/sports/${event.id}`}
          className="rns-book"
          target="_blank"
          rel="noopener noreferrer"
        >
          Book Now
        </Link>
      </div>
    </div>
  );
}
